import React from 'react';
import { Handle, Position } from 'reactflow';
import { motion } from 'framer-motion';
import { Sparkles, Zap } from 'lucide-react';

const TopicNode = ({ data }) => {
  const { topic, viralHook, output, onClick } = data;

  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick(data);
    }
  };

  return (
    <motion.div
      className="topic-node cursor-pointer"
      data-testid="topic-node"
      onClick={handleClick}
      whileHover={{ scale: 1.03, y: -4 }}
      whileTap={{ scale: 0.98 }}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 200, damping: 15 }}
      style={{ pointerEvents: 'all' }}
    >
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: '#FF7F00', width: 6, height: 6 }}
      />
      
      <div className="topic-node-title">
        {topic}
      </div>
      
      {viralHook && (
        <div className="mt-2 text-xs text-gray-500 italic line-clamp-2">
          "{viralHook}"
        </div>
      )}
      
      <div className="flex items-center gap-2 mt-3">
        <span className="topic-node-badge">
          <Sparkles className="w-3 h-3" />
          Generate {output}
        </span>
        <span className="flex items-center gap-1 text-[10px] text-[#0070FF] font-medium">
          <Zap className="w-3 h-3" />
          Viral Ready
        </span>
      </div>

      <Handle
        type="source"
        position={Position.Right}
        style={{ background: '#0070FF', width: 6, height: 6 }}
      />
    </motion.div>
  );
};

export default TopicNode;
